import { IconPlayButton } from '@vs-shop/ui/icons';
import type { GalleryMediaT } from '../../../../../type/galleryMediaT';

import {
  ProductGalleryThumb,
  ProductGalleryThumbFrame,
  ProductGalleryThumbImage,
  ProductGalleryThumbMark,
  ProductGalleryVariant,
} from '@vs-shop/commerce-ui/productGallery';

import { resolveImageUrl } from '@vs-shop/engine/image/resolveImageUrl';

import { getYoutubeThumbnailPath } from '../../../../../effect/utils/youtube/youtube';
import { ImageFilter } from '@vs-shop/engine/image/ImageFilter';

type Props = {
  media: GalleryMediaT;
  selected: boolean;
  onClick: () => void;
  alt: string;
};

/**
 * One cell of the lightbox's thumb column. Resolving a medium to a thumbnail URL
 * is this tenant's — a photograph through its own filter, a video through its
 * host's still — and so is what the cell is called.
 */
export function GalleryModalThumbItem({ media, selected, onClick, alt }: Props) {
  const mediaIdentifier = media.mediaType === 'image' ? (media.pathAbstract ?? '') : media.path;
  const ariaLabel = mediaIdentifier === '' ? alt : `${alt} – ${mediaIdentifier}`;

  return (
    <ProductGalleryThumb
      variant={ProductGalleryVariant.OVERLAY}
      tabIndex={0}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-current={selected ? true : undefined}
    >
      {media.mediaType === 'image' ? (
        <ProductGalleryThumbImage
          variant={ProductGalleryVariant.OVERLAY}
          src={
            media.pathAbstract
              ? resolveImageUrl(media.pathAbstract, ImageFilter.product_gallery_modal_main)
              : ''
          }
          alt={alt}
          width={80}
          height={60}
        />
      ) : (
        <ProductGalleryThumbFrame>
          <ProductGalleryThumbImage
            variant={ProductGalleryVariant.OVERLAY}
            src={getYoutubeThumbnailPath(media.path)}
            alt={alt}
            width={80}
            height={60}
          />
          <ProductGalleryThumbMark>
            <IconPlayButton className="h-full w-full" />
          </ProductGalleryThumbMark>
        </ProductGalleryThumbFrame>
      )}
    </ProductGalleryThumb>
  );
}
